export default __webpack_public_path__ + "static/grades_eemb-d1156818805c42c432cabbb68767a457.png";